import { render, staticRenderFns } from "./post-wizard.vue?vue&type=template&id=db193dd6"
import script from "./post-wizard.vue?vue&type=script&lang=js"
export * from "./post-wizard.vue?vue&type=script&lang=js"
import style0 from "./post-wizard.vue?vue&type=style&index=0&id=db193dd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./post-wizard.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports